var map = {
	"./case-id-tooltip-de.jpg": 485,
	"./case-id-tooltip-en.jpg": 486,
	"./case-id-tooltip-es.jpg": 487,
	"./case-id-tooltip-pl.jpg": 488
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 716;